<template>
  <v-app>
    <v-container grid-list-lg>
      <v-row class="row wrap justify-center ma-0">
        <v-col class="col-12 col-md-8">
          <div class="row">
            <div class="flex pa-0 col-12">
              <h2 class="primary--text">{{item.title}}</h2>
              <v-divider class="my-2"></v-divider>
              <!-- <p style="color: #707070">Atualizado em 27/01/2019</p> -->
            </div>
            <div v-html="item.content" class="o-html overflow-y-auto"></div>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </v-app>
</template>

<script>
import http from '@/services/httpClient';

export default {
  data() {
    return {
      item: {},
    };
  },
  created() {
    const { id } = this.$route.params;
    this.getDataPage(id);
  },
  methods: {
    getDataPage(id) {
      http
        .get(`/static_pages/${id}`)
        .then((response) => {
          this.item = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
  },
};
</script>
<style scoped>
.o-html > * {
  word-break: break-word;
}
</style>
